import React from 'react';
import { useLocation } from 'react-router-dom';
import SectionFilterForm from './SectionFilterForm';
import css from '../SearchPage.module.css';
import { useRouteConfiguration } from '../../../context/routeConfigurationContext';
import { createResourceLocatorString } from '../../../util/routes';
import { SearchType } from '../../../util/enums';
import { mergeSearchPageQueryParams } from '../../../util/searchPageQueryParams';
import { parse } from '../../../util/urlHelpers';

function SectionTopbarFilter(props) {
  const { intl, viewport, history, isSearchPageFilter } = props;
  const routeConfiguration = useRouteConfiguration();
  const location = useLocation();
  const { keywords } = parse(location?.search || '');

  const handleSubmit = values => {
    const submittedSearchType =
      values?.searchType === SearchType.KEYWORDS ? SearchType.KEYWORDS : SearchType.LOCATION;
    const queryParams = mergeSearchPageQueryParams({
      currentSearch: location?.search,
      values: {
        ...values,
        searchType: submittedSearchType,
      },
    });

    const path = createResourceLocatorString('SearchPage', routeConfiguration, {}, queryParams);
    history.push(path, { searchType: submittedSearchType });
  };

  return (
    <div className={css.filterSection}>
      <SectionFilterForm
        initialValues={{
          searchType: SearchType.KEYWORDS,
          keywords: keywords || '',
        }}
        rootClassName={css.searchPageForm}
        onSubmit={handleSubmit}
        intl={intl}
        viewport={viewport}
        isSearchPageFilter={isSearchPageFilter}
      />
    </div>
  );
}

export default SectionTopbarFilter;
